import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { legalDocuments } from "@/content/legalDocuments";

export default function PrivacyPolicy() {
  return <LegalDocumentPage document={legalDocuments.privacy} />;
}